<template>
  <div>
    <v-layout
      wrap
      align-start
    >
      <v-flex
        v-if="bookingForm.booking.card_payment_type == 'prepaid'"
        xs12
        px-2
        pt-2
      >
        <v-alert
          dense
          color="red"
          border="top"
        >
          <p>
            This trip has been
            <b>prepaid</b>. Changing booking parameters will not affect final
            cost.
          </p>
        </v-alert>
      </v-flex>
      <v-flex>
        <v-layout
          wrap
        >
          <v-flex
            pt-3
            ml-1
            md4
          >
            <label class="cmr-book-form-label">Payment Type</label>
            <SelectablePaymentTypeInput
              :payment-type="bookingForm.booking.payment_type"
              :payment-types="bookingForm.paymentTypes()"
              :user="bookingForm.user"
              :error="bookingForm.errors.payment_type"
              @input="changePaymentType"
            />
          </v-flex>
          <v-flex
            pl-1
            pt-3
            shrink
            :class="{ 'disabled-panel': bookingIsCompletedOrCancelled }"
          >
            <v-row>
              <v-flex shrink>
                <label class="cmr-book-form-label">{{ 'Cards' }}</label>
                <v-btn
                  v-if=" bookingForm.user.contact_number.length > 0 && !bookingIsCompletedOrCancelled"
                  x-small
                  fab
                  elevation="0"
                  color="blue"
                  class="small-icon-bg"
                >
                  <v-icon
                    color="white"
                    icon
                    small

                    @click="addingCard = true"
                  >
                    mdi-plus
                  </v-icon>
                </v-btn>
                <SelectableCardInput
                  :cards="bookingForm.user.cards"
                  :card="bookingForm.booking.card"
                  :enabled="bookingForm.booking.payment_type == 'card'"
                  :error="bookingForm.errors.card"
                  @input="changePaymentTypeToCard"
                />
              </v-flex>
            </v-row>
          </v-flex>
          <v-flex
            shrink
            pt-3
            pl-1
            :class="{ 'disabled-panel': bookingIsCompletedOrCancelled }"
          >
            <v-layout>
              <v-flex shrink>
                <label class="cmr-book-form-label">Promo</label>
                <v-btn
                  v-if="!bookingIsCompletedOrCancelled && bookingForm.user.contact_number.length > 0"
                  x-small
                  fab
                  elevation="0"
                  color="blue"
                  class="small-icon-bg ml-1"
                >
                  <v-icon
                    small
                    color="white"
                    icon
                    @click="addingPromocode = true"
                  >
                    mdi-plus
                  </v-icon>
                </v-btn>
                <v-btn
                  v-if="bookingForm.booking.promocode"
                  x-small
                  fab
                  elevation="0"
                  color="blue lighten-5"
                  class="small-icon-bg"
                >
                  <v-icon
                    small
                    color="red"
                    @click="bookingForm.booking.promocode = null"
                  >
                    close
                  </v-icon>
                </v-btn>
                <SelectablePromocodeInput
                  :enabled="true"
                  :promocode="bookingForm.booking.promocode"
                  :promocodes="bookingForm.user.promocodes"
                  :booking="bookingForm.booking"
                  :booking-form="bookingForm"
                  :error="bookingForm.errors.promocode"
                  @input="changePromocode"
                />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            v-if="getCost() != null"
            pl-1
            pt-3
            shrink
          >
            <label class="cmr-book-form-label">Additional Charges
              <span
                v-if="costOfAdditionals() != null && costOfAdditionals() != 0"
                style="font-weight: 500"
              >
                £{{ costOfAdditionals() }}
              </span>
            </label>
            <BookingAdditionalChargeSummary
              :booking="bookingForm.booking"
              :label="''"
              @getCostEstimate="getCostEstimate"
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex>
        <v-layout
          v-if="!bookingIsCancelled"
          shrink

          ma-1
          mt-0
          pr-2
          wrap
          pt-1
          :class="{ 'change-cost-panel': bookingIsCompletedOrCancelled }"
          class="enabled-panel"
        >
          <v-flex
            lg12
            xl12
            md12
          >
            <v-layout>
              <v-flex
                pt-2
                shrink
              >
                <div>
                  <SimpleCurrencyInput
                    v-model="bookingForm.booking.final_fare"
                    label="Final Fare"
                    :error="bookingForm.errors.final_cost"
                    @input="finalCostChanged"
                  />
                  <p
                    v-if="
                      bookingForm.booking.final_cost_promotion != null &&
                        bookingForm.booking.final_cost_promotion != 0
                    "
                  >
                    Final Cost Promotion: £{{
                      bookingForm.booking.final_cost_promotion.toFixed(2)
                    }}
                  </p>
                </div>
              </v-flex>
              <!--
              <v-flex
                pt-2
                shrink
                px-1
              >
                <div
                  v-if="
                    (bookingForm.booking.payment_type == 'card' ||
                      bookingForm.booking.payment_type == 'account') &&
                      bookingForm.booking.fixed_cost == true
                  "
                >
                  <SimpleCurrencyInput
                    v-model="bookingForm.booking.final_cost_driver"
                    label="Driver Cost"
                    :error="bookingForm.errors.final_cost_driver"
                    @input="finalCostDriverChanged"
                  />
                </div>
              </v-flex>
-->
              <!--
              <v-flex
                v-if="!bookingIsCompletedOrCancelled"
                pt-2
                px-1
                shrink
              >
                <div>
                  <SimpleCurrencyInput
                    v-model="bookingForm.booking.fixed_commission"
                    label="Commission"
                    :error="bookingForm.errors.final_cost"
                  />
                </div>
              </v-flex>
-->
              <v-flex
                pt-2
                px-1
              >
                <p
                  v-if="finalCostIncludingAdditionalsAndPromoCode()"
                  class="mt-6 mrc-text-12-bold"
                >
                  <span class="cmr-label-text">
                    Customer Pays
                  </span>
                  <span class="mrc-metallic-green" :class="{ 'fare-strike-through': bookingForm.booking.promocode}">£{{ finalCostIncludingAdditionals() }}</span>
                  <span class="mrc-metallic-green" v-if="bookingForm.booking.promocode">
                    <v-icon small>mdi-arrow-right</v-icon>
                    £{{ finalCostIncludingAdditionalsAndPromoCode() }}
                  </span>
                </p>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            v-if="bookingIsCompletedOrCancelled"
            pt-2
            pt-1
            pl-2
          >
            <v-btn
              small
              class="text-none"
              @click="updateFinalCosts"
            >
              Update Costs
            </v-btn>
            <p />
          </v-flex>
          <v-flex
            md12
            lg12
            xl12
            shrink
          >
            <EstimatedCost
              :booking-form="bookingForm"
              @getCostEstimate="getCostEstimate"
            />
          </v-flex>
          <v-flex
            xs12
            md12
            lg12
            xl12
            pt-3
          >
            <v-layout>
              <v-flex
                md12
                lg12
                xl12
              >
                <v-divider
                  style="margin-top: 7px; margin-bottom: 7px; width: 100%"
                />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            xs12
            md12
            lg12
            xl12
            pb-2
          >
            <DriverPaymentInput
              :booking-form="bookingForm"
              @updateFinalCosts="updateFinalCosts"
            />
          </v-flex>
          <v-flex
            md12
            lg12
            xl12
          >
            <v-divider
              style="margin-top: 7px; margin-bottom: 7px; width: 100%"
            />
          </v-flex>
          <v-flex
            v-if="large"
            xs12
            md12
            lg12
            xl12
          >
            <v-row>
              <v-flex shrink>
                <h4>Fare Breakdown</h4>
              </v-flex>
              <v-flex
                v-if="bookingForm.fareBreakdown != null"
                shrink
              />
            </v-row>
          </v-flex>
          <v-flex xs12>
            <v-row>
              <v-flex shrink>
                <FareBreakdown :booking="bookingForm.booking" :breakdown="bookingForm.bookingCostBreakdown" />
              </v-flex>
              <v-flex
                v-if="bookingForm.fareBreakdown != null"
                shrink
              >
                <FareBreakdown :booking-form="bookingForm.fareBreakdown" />
              </v-flex>
            </v-row>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="addingCard"
      persistent
      min-width="100%"
      max-width="400"
    >
      <v-card>
        <v-card-actions>
          <v-layout justify-space-between>
            <v-card-title
              class="headline"
              style="font-weight: 600"
            >
              Add Card
            </v-card-title>
            <v-btn
              icon
              flat="flat"
              @click="addingCard = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
        </v-card-actions>
        <CardInput
          :booking-form="bookingForm"
          @gotCard="changePaymentTypeToCardWithToken"
        />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="addingPromocode"
      persistent
      min-width="100%"
      max-width="400"
    >
      <v-card>
        <v-card-actions>
          <v-layout justify-space-between>
            <v-card-title
              class="headline"
              style="font-weight: 600"
            >
              Add Promocode
            </v-card-title>
            <v-btn
              icon
              flat="flat"
              @click="addingPromocode = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
        </v-card-actions>
        <PromocodeInput
          :booking-form="bookingForm"
          @addedPromocode="changePromocode"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BookingDateInput from "@/components/widget/input/BookingDateInput.vue";
import SimpleTextInput from "@/components/widget/input/SimpleTextInput.vue";
import SimpleNumberInput from "@/components/widget/input/SimpleNumberInput.vue";
import SelectableInput from "@/components/widget/input/SelectableInput.vue";
import SelectablePaymentTypeInput from "@/components/widget/input/SelectablePaymentTypeInput.vue";
import SelectablePromocodeInput from "@/components/widget/input/SelectablePromocodeInput.vue";
import SelectableCardInput from "@/components/widget/input/SelectableCardInput.vue";
import SimpleCurrencyInput from "@/components/widget/input/SimpleCurrencyInputV2.vue";

import CardInput from "@/components/widget/input/CardInput.vue";
import PromocodeInput from "@/components/widget/input/PromocodeInput.vue";

import EstimatedCost from "@/components/widget/input/EstimatedCostV2.vue";

import FareBreakdown from "@/components/widget/input/FareBreakdown.vue";
import BookingAdditionalChargeSummary from "@/components/widget/input/BookingAdditionalChargeSummary.vue";
import DriverPaymentInput from './DriverPaymentInput'


export default {
  name: "PaymentInput",
  components: {
    DriverPaymentInput,
    BookingDateInput,
    EstimatedCost,
    SimpleTextInput,
    SelectableInput,
    SelectablePaymentTypeInput,
    SelectablePromocodeInput,
    SimpleNumberInput,
    SimpleCurrencyInput,
    SelectableCardInput,
    CardInput,
    PromocodeInput,
    FareBreakdown,
    BookingAdditionalChargeSummary
  },
  model: {
    prop: "content",
    event: "input",
  },
  props: {
    content: String,
    label: String,
    required: Boolean,
    errorMessages: Object,
    bookingForm: Object,
    hideAdditionalCharge: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      menu: false,
      addingCard: false,
      addingPromocode: false,
    };
  },
  computed: {
    bookingIsNotBooked() {
      return this.bookingForm.booking.state == null;
    },
    bookingIsCancelled() {
      return this.bookingForm.booking.state == "cancelled";
    },
    bookingIsCompletedOrCancelled() {
      return (
          this.bookingForm.booking.state == "completed" ||
          this.bookingForm.booking.state == "cancelled"
      );
    },
  },
  watch: {
    "bookingForm.booking.promocode" () {
      console.log('promocode changed')
      this.getCostPromotion()
      this.finalCostIncludingAdditionalsAndPromoCode()
    }
  },
  methods: {
    getCostPromotion: function () {
      if (this.bookingForm.costs != null && this.bookingForm.booking.promocode) {
        var bookingForm = this.bookingForm;

        var costForRideType = bookingForm.costs.find(function (cost) {
          return cost.id == bookingForm.booking.ride_type;
        });

        if (costForRideType != null) {
          return costForRideType.estimate_promotion;
        } else {
          return null;
        }
      }
      return null
    },
    updateDriverCommission () {
      var final_fare = this.bookingForm.booking.final_cost_driver
      if (!final_fare) {
        final_fare = this.bookingForm.booking.final_fare
      }
      this.bookingForm.booking.driver_fare_commission = this.bookingForm.booking.commission_from_driver * final_fare
    },
    finalCostIncludingAdditionalsAndPromoCode: function () {
      var additionalCharges = 0;

      for (var i = 0; i < this.bookingForm.booking.bookingAdditionalCharges.length; i++) {
        if ( this.bookingForm.booking.bookingAdditionalCharges[i].enabled == true) {
          additionalCharges += this.bookingForm.booking.bookingAdditionalCharges[i].amount;
        }
      }
      let promocodeAmount = 0;
      if (this.getCostPromotion()) {
        promocodeAmount = this.getCostPromotion()
      }
      console.log('error in promocode amount ' + promocodeAmount)
      // return ((promocodeAmount + additionalCharges)/100).toFixed(2)
      return ((promocodeAmount)/100).toFixed(2)
   /*   if (this.bookingForm.booking.final_fare != 0) {
        var finalFare = this.bookingForm.booking.final_fare;
        console.log("final fare",  finalFare)
        if (finalFare != 0 && finalFare != null) {
          return (((finalFare) + additionalCharges / 100) - (promocodeAmount != null ? promocodeAmount : 0)).toFixed(2);
        } else {
          if (this.getCost()) {
            return ((this.getCost()/100 + additionalCharges / 100) - (promocodeAmount != null ? promocodeAmount : 0)).toFixed(2);
          }
        }
      } else {
        return null;
      }*/
    },
    finalCostIncludingAdditionals: function () {
      var additionalCharges = 0;

      for (var i = 0; i < this.bookingForm.booking.bookingAdditionalCharges.length; i++) {
        if ( this.bookingForm.booking.bookingAdditionalCharges[i].enabled == true) {
          additionalCharges += this.bookingForm.booking.bookingAdditionalCharges[i].amount;
        }
      }
      if (this.bookingForm.booking.final_fare != 0) {
        var finalFare = this.bookingForm.booking.final_fare;
        console.log("final fare",  finalFare)
        if (finalFare != 0 && finalFare != null) {
          return (((finalFare) + additionalCharges / 100)).toFixed(2);
        } else {
          if (this.getCost()) {
            // return ((this.getCost()/100 + additionalCharges / 100)).toFixed(2);
            return ((this.getCost()/100)).toFixed(2);
          }
        }
      } else {
        return null;
      }
    },
    costOfAdditionals: function () {
      var additionalCharges = 0;

      for (var i = 0; i < this.bookingForm.booking.bookingAdditionalCharges.length; i++) {
        if ( this.bookingForm.booking.bookingAdditionalCharges[i].enabled == true) {
          additionalCharges += this.bookingForm.booking.bookingAdditionalCharges[i].amount;
        }
      }

      return (additionalCharges / 100).toFixed(2);
    },
  getCost: function () {
      if (this.bookingForm.costs != null) {
        var bookingForm = this.bookingForm;

        var costForRideType = bookingForm.costs.find(function (cost) {
          return cost.id == bookingForm.booking.ride_type;
        });
        if (costForRideType != null) {
          return costForRideType.estimate;
        } else {
          return null;
        }
      }
    },
    finalCostChanged: function (finalCost) {
      console.log("FINAL COST CHANGED " + finalCost);
      this.bookingForm.updateDriverCommission()
      this.bookingForm.booking.final_fare = finalCost;

      if (finalCost != null) {
        this.bookingForm.booking.fixed_cost = true;

        if (this.bookingForm.booking.fixedCostType != null
            && this.bookingForm.booking.fixedCostType == this.bookingForm.FIXED_COST_AREA() ) {

          if ((finalCost * 100).toFixed(0) != this.bookingForm.booking.fixed_cost_without_extras) {
            this.bookingForm.booking.fixedCostType = this.bookingForm.FIXED_COST_DISPATCHER();
          } else {
            console.log("Not setting to fixed cost dispatcher");
          }

        } else {
          this.bookingForm.booking.fixedCostType = this.bookingForm.FIXED_COST_DISPATCHER();
        }
      } else {
        this.bookingForm.booking.fixed_cost = false;
        this.bookingForm.booking.fixedCostType = null;

        this.bookingForm.booking.final_cost_driver = null;
        this.bookingForm.booking.fixed_cost_driver = false;
        this.bookingForm.booking.fixedCostDriverType = null;
      }

      if (this.bookingForm.booking != null) {
        this.bookingForm.getCostEstimate();
      }
    },
    finalCostDriverChanged: function (finalCost) {
      console.log("changed " + finalCost);

      this.bookingForm.booking.final_cost_driver = finalCost;

      if (finalCost != null) {
        this.bookingForm.booking.fixed_cost_driver = true;
        this.bookingForm.booking.fixedCostDriverType = this.bookingForm.FIXED_COST_DISPATCHER();
      } else {
        this.bookingForm.booking.fixed_cost_driver = false;
        this.bookingForm.booking.fixedCostDriverType = null;
      }
    },
    updateFinalCosts: function () {
      this.$emit("updateFinalCosts", null);
    },
    changePaymentTypeToCard: function (card) {
      console.log("CHANGE PAYMENT TYPE TO CARD");
      this.bookingForm.changePaymentType("card", card);
    },
    changePaymentType: function (paymentType) {
      this.bookingForm.changePaymentType(paymentType, null);
    },
    // changePromocode: function (promocode) {
    //   this.bookingForm.changePromocode(promocode);
    // },
    changeAdditionalCharge: function (additionalCharge) {
      this.bookingForm.additional_charge = additionalCharge;
      this.bookingForm.getCostEstimate();
    },
    getCostEstimate: function() {
      this.bookingForm.getCostEstimate();
    },
    changeFinalCost: function (finalCost) {

      console.log("FINAL COST CHANGED DISPATCHER" + finalCost);

      this.bookingForm.booking.final_cost = finalCost;
    },
    changeFinalCostDriver: function (finalCostDriver) {
      this.bookingForm.booking.final_cost_driver = finalCostDriver;
      this.bookingForm.booking.fixedCostDriverType = this.bookingForm.FIXED_COST_DISPATCHER();
    },
    changePaymentTypeToCardWithToken(token) {
      this.addingCard = false;
      this.bookingForm.changePaymentType("card", token.card.id);
    },
    changePromocode(promocode) {
      this.addingPromocode = false;
      this.bookingForm.changePromocode(promocode);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.disabled-panel {
  pointer-events: none;
}

.enabled-panel {
  pointer-events: auto;
}

.change-cost-panel {
  padding: 8px;
  background-color: #e3f2fd;
}

.compact-form {
  transform: scale(0.875);
  transform-origin: left;
}

.small-fab {
  transform: scale(0.7);
  transform-origin: bottom;
}

.small-fab button {
  margin-left: 0px !important;
  margin-right: 0px !important;
}


.fare-strike-through {
  text-decoration: underline;
  text-underline-offset: -39%; /* <-- this */
  text-decoration-skip-ink: none;
}

</style>
